import { combineReducers } from '@reduxjs/toolkit'
import authReducer from './authReducer'
import alertReducer from './alertReducer'
import loadingReducer from './loadingReducer'
import memberReducer from './memberReducer'
import clientReducer from './clientReducer'
import siteReducer from './siteReducer'
import testReducer from './testReducer'
import superAdminReducer from './superAdminReducer'
import logReducer from './logReducer'
import procedureReducer from './procedureReducer'
import doctorReducer from './doctorReducer'
import medicalEquipmentReducer from './medicalEquipmentReducer'
import roomReducer from './roomReducer'
import roleReducer from './roleReducer'
import itEquipmentReducer from './itEquipmentReducer'
import questionReducer from './questionReducer'
import ambulanceReducer from './ambulanceReducer'
import statsReducer from './statsReducer'
import medicalOrderReducer from './medicalOrderReducer'
import patientsReducer from './patientsReducer'
import billingReducer from './billingReducer'
import orderReducer from './orderReducer'
import visitReducer from './visitReducer'
import organismReducer from './organismReducer'
import cashRegisterReducer from './cashRegisterReducer'
import aldReducer from './aldReducer'
import recipientReducer from './recipientReducer'
import paymentModeReducer from './paymentModeReducer'
import billingCompanyReducer from './billingCompanyReducer'
import bankEstablishmentReducer from './bankEstablishmentReducer'
import bankAccountReducer from './bankAccountReducer'
import patientPaymentReducer from './patientPaymentReducer'
import chequeDepositReducer from './chequeDepositReducer'
import quoteReducer from './quoteReducer'
import invoiceReducer from './invoiceReducer'
import lotReducer from './lotReducer'
import documentConfigReducer from './documentConfigReducer'
import acqProtocolReducer from './acqProtocolReducer'
import reportReducer from './reportReducer'
import dmpReducer from './dmpReducer'
import mssReducer from './mssReducer'
import isotopeReducer from './isotopeReducer'
import compoundReducer from './compoundReducer'
import functionalUnitReducer from './functionalUnitReducer'
import supplierReducer from './supplierReducer'
import storageLocationReducer from './storageLocationReducer'
import productCatalogReducer from './productCatalogReducer'
import productFamilyReducer from './productFamilyReducer'
import injectionSiteReducer from './injectionSiteReducer'
import wasteContainerReducer from './wasteContainerReducer'
import hotLabEquipmentReducer from './hotLabEquipmentReducer'
import memberPreferencesReducer from './memberPreferencesReducer'
import memberPreferenceConfigReducer from './memberPreferenceConfigReducer'
import visualQualityControlReducer from './visualQualityControlReducer'
import customQualityControlReducer from './customQualityControlReducer'
import qualityControlAssignmentReducer from './qualityControlAssignmentReducer'
import activityLimitReducer from './activityLimitReducer'
import compoundProductionStepReducer from './compoundProductionStepReducer'
import compoundProductionStepAssignmentReducer from './compoundProductionStepAssignmentReducer'
import preparationDocumentReducer from './preparationDocumentReducer'
import activimeterDetailReducer from './activimeterDetailReducer'
import activimeterCalibrationReducer from './activimeterCalibrationReducer'
import insiReducer from './insiReducer'
import eventLogReducer from './eventLogReducer'
import entityEventLogReducer from './entityEventLogReducer'
import permissionReducer from './permissionReducer'
import productOrderReducer from './productOrderReducer'
import { scannerReducer } from './scannerReducer'
import stockReducer from './stockReducer'
import stockTransactionReducer from './stockTransactionReducer'
import productBatchReducer from './productBatchReducer'
import stockAlertReducer from './stockAlertReducer'
import productOrderReceiptReducer from './productOrderReceiptReducer'
import appStateReducer from './appReducer'
import commentReducer from './CommentReducer'
import patientContactReducer from './patientContactReducer'
import workbenchReducer from './workbenchReducer'
import generatorElutionReducer from './generatorElutionReducer'
import wasteEntryReducer from './wasteEntryReducer'
import generatorInstanceReducer from './generatorInstanceReducer'
import prescriptionReducer from './prescriptionReducer'
import multistepProtocolReducer from './multistepProtocolReducer'
import ftReducer from './ForfaitReducer'
import preparationLotReducer from './preparationLotReducer'
import operationQualityControlsReducer from './operationQualityControlsReducer'
import organisationReducer from './organisationReducer'
import wasteReducer from './wasteReducer'
import backgroundTasksReducer from './backgroundTaskReducer'

const appReducer = combineReducers({
  superAdmin: superAdminReducer,
  auth: authReducer,
  client: clientReducer,
  site: siteReducer,
  member: memberReducer,
  procedure: procedureReducer,
  examType: procedureReducer,
  doctor: doctorReducer,
  room: roomReducer,
  medicalEquipment: medicalEquipmentReducer,
  forfaitsTechnique: ftReducer,
  itEquipment: itEquipmentReducer,
  alert: alertReducer,
  loading: loadingReducer,
  log: logReducer,
  test: testReducer,
  role: roleReducer,
  permissions: permissionReducer,
  question: questionReducer,
  ambulance: ambulanceReducer,
  stats: statsReducer,
  patients: patientsReducer,
  medicalOrder: medicalOrderReducer,
  billing: billingReducer,
  order: orderReducer,
  visits: visitReducer,
  organisms: organismReducer,
  cashRegister: cashRegisterReducer,
  ald: aldReducer,
  recipient: recipientReducer,
  paymentMode: paymentModeReducer,
  billingCompany: billingCompanyReducer,
  bankEstablishment: bankEstablishmentReducer,
  bankAccount: bankAccountReducer,
  patientPayment: patientPaymentReducer,
  chequeDeposit: chequeDepositReducer,
  quote: quoteReducer,
  invoice: invoiceReducer,
  lot: lotReducer,
  documentConfig: documentConfigReducer,
  acProtocols: acqProtocolReducer,
  reports: reportReducer,
  dmp: dmpReducer,
  mss: mssReducer,
  isotope: isotopeReducer,
  compound: compoundReducer,
  functionalUnits: functionalUnitReducer,
  supplier: supplierReducer,
  storageLocation: storageLocationReducer,
  productCatalog: productCatalogReducer,
  productFamily: productFamilyReducer,
  injectionSite: injectionSiteReducer,
  wasteContainer: wasteContainerReducer,
  hotLabEquipment: hotLabEquipmentReducer,
  visualQualityControl: visualQualityControlReducer,
  customQualityControl: customQualityControlReducer,
  qualityControlAssignment: qualityControlAssignmentReducer,
  activityLimit: activityLimitReducer,
  memberPreferences: memberPreferencesReducer,
  memberPreferenceConfig: memberPreferenceConfigReducer,
  compoundProductionStep: compoundProductionStepReducer,
  compoundProductionStepAssignment: compoundProductionStepAssignmentReducer,
  preparationDocument: preparationDocumentReducer,
  activimeterDetail: activimeterDetailReducer,
  activimeterCalibration: activimeterCalibrationReducer,
  insi: insiReducer,
  eventLog: eventLogReducer,
  entityEventLog: entityEventLogReducer,
  productOrder: productOrderReducer,
  scanner: scannerReducer,
  stock: stockReducer,
  stockTransaction: stockTransactionReducer,
  productBatch: productBatchReducer,
  stockAlert: stockAlertReducer,
  productOrderReceipt: productOrderReceiptReducer,
  app: appStateReducer,
  comment: commentReducer,
  patientContact: patientContactReducer,
  workbench: workbenchReducer,
  generatorElution: generatorElutionReducer,
  wasteEntry: wasteEntryReducer,
  generatorInstance: generatorInstanceReducer,
  prescription: prescriptionReducer,
  multistepProtocol: multistepProtocolReducer,
  preparationLot: preparationLotReducer,
  operationQualityControls: operationQualityControlsReducer,
  organisation: organisationReducer,
  waste: wasteReducer,
  backgroundTasks: backgroundTasksReducer,
})

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT') {
    return appReducer(undefined, action)
  }

  return appReducer(state, action)
}
export default rootReducer
